import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { NativeBaseProvider, extendTheme } from "native-base";
import reportWebVitals from "./reportWebVitals";
import "./assets/custom.css";
import fontsCSS from "@native-base/icons/FontsCSS/index.ts";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { persistor, rrfProps, store } from "./Redux/store";
import "./closestpolyfill";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "",
  environment: process.env.NODE_ENV,
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  integrations: [Sentry.browserTracingIntegration()],
});

const style = document.createElement("style");
style.type = "text/css";
style.appendChild(document.createTextNode(fontsCSS));
document.head.appendChild(style);
if (process.env.NODE_ENV !== "development") console.log = () => {};

const theme = extendTheme({
  config: {
    initialColorMode: "light",
  },
});
const rootElement = document.getElementById("root");

// react-snap pre-renders static HTML at build time. When the browser loads a
// pre-rendered page, hydrate() attaches event handlers without re-creating DOM.
// On non-pre-rendered pages (or during dev), createRoot().render() works normally.
const appTree = (
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <NativeBaseProvider theme={theme}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </NativeBaseProvider>
      </ReactReduxFirebaseProvider>
    </PersistGate>
  </Provider>
);

if (rootElement.hasChildNodes()) {
  // Pre-rendered by react-snap — hydrate to attach event handlers
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  // Normal client-side render (dev or non-pre-rendered routes)
  ReactDOM.createRoot(rootElement).render(appTree);
}

reportWebVitals();
